import http from './http.js';
import { isLogin } from './index.js';
import sha256 from 'crypto-js/sha256';
const baseUrl = 'https://aistudio.cloud.tencent.com/' ;
const defaultUrl = 'https://aistudio.cloud.tencent.com/demo-user/capi/getResult/' ;
// ocr 文字识别
export async function baseOcrRequest({cmd,data,isExample = false,fileType,module,checkLogin = true,config}) {
  let url = isExample ?  'demo-common/democase/getDemoResultByDefaultImage' : 'demo-user/capi/getResult/';
  let payload = {
    ...data
  }
  if(cmd === 'ReconstructDocument' ){
    payload.Config = {
      EnableInsetImage: data.EnableInsetImage === '1' ? true : false
    };
    delete payload.EnableInsetImage;
  }else if(cmd === 'ReconstructDocumentDemo' ){
    payload.FileType = fileType.toUpperCase()
  }

  return http.post({
    url: `${baseUrl}${url}`,
    cmd,
    data:payload,
    module,
    checkLogin,
    config
  });
}
export async function chartOcrRequest(data,isExample = true) {
  let url = isExample ?  'demo-common/democase/getDemoResultByDefaultImage' : 'demo-user/capi/getResult/'
  return http.post({
    url: `${baseUrl}${url}`,
    cmd:'ChatOCR',
    data,
  });
}
export async function chartOcrFeedBackRequest(data) {
  return http.post({
    url: defaultUrl,
    cmd:'ChatOCRDemoFeedBack',
    data,
  });
}
export  async function getProductList(){
  const url = 'demo-common/getProductConfig';
  return http.demoPost({
    url: `${baseUrl}${url}`
  });
}

export  function  pollApi(payload, interval, maxPollCount = 10) {
    let pollCount = 0;
    let canceled = false;
    
    return {
        start: new Promise((resolve, reject) => {
            const executePoll = () => {
                // 检查是否已被取消
                if (canceled) return;
                // 检查是否达到最大轮询次数
                if (pollCount >= maxPollCount) {
                    reject({
                      msg: '网络异常，请重试'
                    });
                    return;
                }
                
                pollCount++;
                
                baseOcrRequest(payload)
                    .then(response => {
                        if (canceled) return;
                        if(response.Error || response.error || response.JobStatus === 'FAIL'){
                          reject(response)
                        }else if (response.JobStatus === 'DONE') {
                        // 检查是否满足成功条件
                            resolve(response);
                        } else {
                            // 继续下一次轮询
                            resolve(response);
                            setTimeout(executePoll, interval);
                        }
                    })
                    .catch(error => {
                        if (canceled) return;
                        reject(error)
                        // 遇到错误继续尝试
                        // setTimeout(executePoll, interval);
                    });
            };
            
            // 开始第一次轮询
            executePoll();
        }),
        cancel: () => {
            canceled = true;
        }
    };
}

export async function getRecentMenu(data) {
  const { QCLogin } = window;
  if(!isLogin) return
  let uin = QCLogin.getUin();
  return http.post({
    url: defaultUrl,
    cmd:'QueryUserInterfaceHistoryAccessRecordForDemo',
    data:{
      ...data,
      Sid:sha256(uin).toString()
    },
    checkLogin:false
  });
}

export async function addRecentMenu(data) {
  const { QCLogin } = window;
  if(!isLogin) throw({
    error: true
  })
  let uin = QCLogin.getUin();

  return http.post({
    url: defaultUrl,
    cmd:'AddUserInterfaceHistoryAccessRecordForDemo',
    data:{
      ...data,
      Sid:sha256(uin).toString()
    },
    checkLogin:false
  });
  
}